/** Max Salesforce token refresh calls per browser tab session (reviewer: 3–5). */
export const MAX_SF_REFRESH_COUNT = 5;

/** Wall-clock cap from first SF session persist in this tab (6 hours). */
export const MAX_SF_SESSION_MS = 6 * 60 * 60 * 1000;

const KEY_START = "sf_session_start_ms";
const KEY_REFRESH_COUNT = "sf_refresh_count";

export function resetSfSessionLimitKeys(): void {
  try {
    window.sessionStorage.removeItem(KEY_START);
    window.sessionStorage.removeItem(KEY_REFRESH_COUNT);
  } catch {
    /* ignore */
  }
}

export function ensureSfSessionStart(): void {
  try {
    if (!window.sessionStorage.getItem(KEY_START)) {
      window.sessionStorage.setItem(KEY_START, String(Date.now()));
    }
  } catch {
    /* ignore */
  }
}

export function isSfSessionExpired(): boolean {
  try {
    const raw = window.sessionStorage.getItem(KEY_START);
    if (!raw) return false;
    const start = Number(raw);
    if (!Number.isFinite(start)) return false;
    return Date.now() - start > MAX_SF_SESSION_MS;
  } catch {
    return false;
  }
}

export function isSfRefreshBudgetExhausted(): boolean {
  try {
    const n = Number(window.sessionStorage.getItem(KEY_REFRESH_COUNT) || "0");
    return Number.isFinite(n) && n >= MAX_SF_REFRESH_COUNT;
  } catch {
    return true;
  }
}

export function incrementSfRefreshCount(): void {
  try {
    const n = Number(window.sessionStorage.getItem(KEY_REFRESH_COUNT) || "0");
    window.sessionStorage.setItem(KEY_REFRESH_COUNT, String(n + 1));
  } catch {
    /* ignore */
  }
}
